export { registerComponent as registerImageComponent } from '../../components/builtin/Image/register'
export { default as Image } from '../../components/builtin/Image/Image'
